import { AttentionPanelItem } from '@/components/ui/AttentionPanel.tsx';
import RowActionsMenu, {
  RowActionsMenuItem,
} from '@/components/ui/RowActionsMenu.tsx';
import { AttentionItemDto } from '@/types/stats/AttentionItemDto.ts';

export interface AttentionItemActionsProps {
  item: AttentionItemDto;
  /** Nagłówek wiersza — bez niego czytnik ekranu słyszy same „Akcje sprawy” przy każdym wierszu. */
  label: string;
  link?: AttentionPanelItem['link'];
  actionLabel?: string;
  onResolve?: (item: AttentionItemDto) => void;
  onReopen?: (item: AttentionItemDto) => void;
}

/**
 * Menu wiersza sprawy: „Odłóż” na liście otwartych, „Przywróć” na liście odłożonych,
 * „Otwórz…” zawsze, gdy wiersz ma cel. Pozycja bez spraw nie ma czego odkładać — przycisk znika.
 */
const AttentionItemActions = ({
  item,
  label,
  link,
  actionLabel,
  onResolve,
  onReopen,
}: AttentionItemActionsProps) => {
  const resolvable = item.findingIds.length > 0;

  const entries: RowActionsMenuItem[] = [];
  if (onResolve && !item.resolution && resolvable) {
    entries.push({ label: 'Odłóż', onSelect: () => onResolve(item) });
  }
  if (onReopen && item.resolution && resolvable) {
    entries.push({ label: 'Przywróć', onSelect: () => onReopen(item) });
  }
  if (link) {
    entries.push({ label: actionLabel ?? 'Otwórz', link });
  }

  return <RowActionsMenu label={label} items={entries} />;
};

export default AttentionItemActions;
